//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {

    props: {
        item: {
            required: true
        },
        value: {
            type: [String, Number],
            default: 1
        },
        stock: {
            type: [String, Number],
            required: true,
            default: null
        },
        in_unit: {
            type: [String, Number],
            default: ''
        },
        readonly: {
            default: false
        }
    },

    data: function data() {
        return {
            qty: null,
            loading: false,
            removing: false,
            initialized: false
        };
    },
    created: function created() {
        this.qty = this.value;
        this.$emit('change', this.qty);
    },


    methods: {
        updateQty: function updateQty() {
            var _this = this;

            if (this.qty < 1) {
                this.qty = 1;
            }
            if (parseInt(this.qty) > parseInt(this.stock)) {
                this.qty = this.stock;
                swal("", "Sie möchten dem Warenkorb mehr Produkte hinzufügen, als wir auf Lager haben.", "error");
            } else {
                // Prevent update on first load.
                if (this.initialized && !this.loading) {
                    this.loading = true;
                    new Form({ rowId: this.item.rowId, qty: this.qty }).post('/api/cart/update').then(function (response) {
                        if (response.error) {
                            swal({
                                html: true,
                                title: '',
                                text: response.error_text,
                                type: "error"
                            });
                            _this.qty = response.qty;
                        } else {
                            App.event.fire('cart.updated', response);
                        }
                        _this.loading = false;
                    });
                }
                this.initialized = true;
            }
        },
        remove: function remove() {
            var _this2 = this;

            this.removing = true;
            new Form({ rowId: this.item.rowId }).post('/api/cart/remove').then(function (response) {
                App.event.fire('cart.updated', response);
                _this2.removing = false;
            });
        }
    },

    computed: {
        numberFormat: function numberFormat() {
            return parseInt(this.item.orgPrice);
        },
        subtotal: function subtotal() {
            return parseInt(this.item.orgPrice * this.item.qty);
        },
        removeIcon: function removeIcon() {
            return this.removing ? 'fa fa-spinner fa-spin' : 'fa fa-times';
        },
        url: function url() {
            return '/product/' + this.item.seo;
        }
    }

};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}],"syntax-dynamic-import"]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/templates/semperit/assets/js/modules/checkout/components/cart/components/CartRow.vue
// module id = KCic
// module chunks = 4